import ActiveStorageDragAndDrop from 'active_storage_drag_and_drop';
ActiveStorageDragAndDrop.start()